import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';
import { escapeCurrency, holdOpenLink, holdOpenMath, rehypeGlueMath } from '../data/buffyMath';

// Buffy's markdown replies (Home chat, the question teaching note). The
// prompt has him write math as inline LaTeX between single dollars, and plain
// ReactMarkdown printed those dollars as text (Sandy 2026-10-02: "$x^2 + 3$").
// remark-math + rehype-katex render it as real math, the same pair the
// student AI tutor (Homework/AiTutor.jsx) uses; escapeCurrency keeps bare
// prices ("$40 to $20") out of the math, and rehypeGlueMath keeps a trailing
// "." on the math's line. `streaming`: the reply is still arriving, so an
// unclosed "$..." or "[label](target" at the end is held back. `gfm`: GitHub tables and lists,
// which the admin chats use (2026-10-02: the admin chats render through here).
const REMARK = [remarkMath];
const REMARK_GFM = [remarkGfm, remarkMath];
const REHYPE = [rehypeKatex, rehypeGlueMath];

export default function BuffyMarkdown({ children, streaming = false, gfm = false, components }) {
  const text = escapeCurrency(children);
  return (
    <ReactMarkdown remarkPlugins={gfm ? REMARK_GFM : REMARK} rehypePlugins={REHYPE} components={components}>
      {streaming ? holdOpenLink(holdOpenMath(text)) : text}
    </ReactMarkdown>
  );
}
